// extracted by mini-css-extract-plugin
export default {"calendar":"_1AoEZ","mobile":"_2KBuJ"};